/* istanbul ignore file */
import { FieldProps, TextField, useFieldHelper } from 'framework/ui/field';
import { useAuthorization } from 'framework/authorization';
import { ProjectLink, READ_PROJECT } from 'domain/shared/project';
import { AssignmentTargetType } from '../assignmentTargetService';
import { READ_SERVICE, ServiceLink } from 'domain/shared/service';
import { ServiceCatalogLinkFieldWithNameLoading } from 'domain/shared/serviceCatalog';

const getTargetLink = (
  type: string,
  name: string,
  serviceCatalogIdSource: string,
  isGranted: Function,
  getId: Function,
  props: any,
) => {
  switch (type) {
    case AssignmentTargetType.PROJECT.toString():
      return <ProjectLink isClickable={isGranted(READ_PROJECT)} name={name} id={getId()} {...props} />;
    case AssignmentTargetType.SERVICE.toString():
      return <ServiceLink isClickable={isGranted(READ_SERVICE)} name={name} id={getId()} {...props} />;
    case AssignmentTargetType.SERVICE_CATALOG_SERVICE.toString():
      return <ServiceCatalogLinkFieldWithNameLoading source={serviceCatalogIdSource} {...props} />;
    default:
      return null;
  }
};

const AssignmentTargetLinkField = ({
  source,
  nameSource,
  typeSource,
  serviceCatalogIdSource,
  ...props
}: FieldProps) => {
  const { getValue: getId } = useFieldHelper({ source });
  const { getValue: getType } = useFieldHelper({ source: typeSource });
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const { isGranted } = useAuthorization();

  const name = getName();
  const type = getType();

  const value = getTargetLink(type, name, serviceCatalogIdSource, isGranted, getId, props);

  return <TextField value={value} {...props} />;
};

export default AssignmentTargetLinkField;
